// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import DateInputController from "./date_input_controller"
application.register("date-input", DateInputController)

import LocalstorageController from "./localstorage_controller"
application.register("localstorage", LocalstorageController)

import PreviewController from "./preview_controller"
application.register("preview", PreviewController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import TableToggleController from "./table_toggle_controller"
application.register("table-toggle", TableToggleController)

import TableExpandController from "./table_expand_controller"
application.register("table-expand", TableExpandController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import UserTrainingController from "./user_training_controller"
application.register("user-training", UserTrainingController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import TableClickController from "./table_click_controller"
application.register("table-click", TableClickController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import CardClickController from "./card_click_controller"
application.register("card-click", CardClickController)
